import { observer } from 'mobx-react-lite';
import Skeleton from 'react-loading-skeleton';
import { useStore } from '../../../stores/store';
import CheckboxPlain from '../../../common/checkbox/checkbox-plain.component';
import { NonStandardPackagingContainer } from './non-standard-packaging.styles';

const NonStandardPackaging = () => {
  const {
    parcelCreationStore: {
      deliveryLimitations,
      nonStandardPackaging,
      setNonStandardPackaging,
      prefillInProgress,
      isDocumentShipmentType,
    },
    shipmentCountriesStore: { isDirectionsListApiLoading },
  } = useStore();

  const packaging = deliveryLimitations?.nonStandardPackaging;
  const showSkeleton = prefillInProgress || isDirectionsListApiLoading;

  if (isDocumentShipmentType) return null;

  return showSkeleton ? (
    <NonStandardPackagingContainer aria-hidden='true'>
      <div className='non-standard-packaging-skeleton-label'>
        <Skeleton
          width='1.8rem'
          height='1.8rem'
          borderRadius={4}
        />
        <Skeleton
          containerClassName='non-standard-packaging-skeleton-text'
          width='100%'
          height='2rem'
          borderRadius={6}
        />
      </div>
      <div className='non-standard-packaging-hint non-standard-packaging-skeleton-hint'>
        <Skeleton
          width='100%'
          height='2rem'
          borderRadius={6}
        />
      </div>
    </NonStandardPackagingContainer>
  ) : (
    packaging?.enabled && (
      <NonStandardPackagingContainer>
        <CheckboxPlain
          name='non_standard_packaging'
          ariaLabel={packaging.text}
          isChecked={nonStandardPackaging}
          onChange={(event) => setNonStandardPackaging(event.target.checked)}>
          {packaging.text}
        </CheckboxPlain>
        {packaging.hint && (
          <div className='non-standard-packaging-hint'>{packaging.hint}</div>
        )}
      </NonStandardPackagingContainer>
    )
  );
};

export default observer(NonStandardPackaging);
